import clsx from "clsx";
import { SwitchField } from "common";
import { produce } from "immer";
import { isNil, set } from "lodash";
import React from "react";
import { SplitPaymentPreference } from "types";
import { TimePickerPopover } from "../../../Common/TimePickerPopover";

interface SplitPaymentPreferenceFormProps {
    value: SplitPaymentPreference;
    errors?: any;
    onChange: (value: SplitPaymentPreference) => void;
}

export const SplitPaymentPreferenceForm = ({ value, errors, onChange }: SplitPaymentPreferenceFormProps) => {
    const hasPaymentDeadline = !isNil(value.paymentDeadline);

    const handleChange = (key: string, fieldValue: any) => {
        const currentValue = produce(value, (draft) => {
            set(draft, key, fieldValue);
        });
        onChange(currentValue);
    };

    const handlePaymentDeadlineChange = (enabled: boolean) => {
        handleChange("paymentDeadline", enabled ? 0 : null);
    };

    return (
        <div className="flex flex-col space-y-2">
            <SwitchField
                size="medium"
                isChecked={value.isEnabled}
                onChange={(value) => handleChange("isEnabled", value)}
            >
                <span>Allow organizer to split payment with other guests</span>
            </SwitchField>
            {value.isEnabled ? (
                <div className="ml-10 flex flex-col space-y-2">
                    <SwitchField size="medium" isChecked={hasPaymentDeadline} onChange={handlePaymentDeadlineChange}>
                        <span onClick={(e) => e.stopPropagation()}>
                            <span>payment must be made</span>
                            <TimePickerPopover
                                showArrow
                                disabled={!hasPaymentDeadline}
                                classNames={{
                                    text: clsx(
                                        "px-0.5 pb-0.5 mx-1",
                                        errors?.paymentDeadline
                                            ? "!text-danger !border-danger"
                                            : "!text-black !border-black",
                                    ),
                                }}
                                value={value?.paymentDeadline ?? 0}
                                onApply={(paymentDeadline: number) => handleChange("paymentDeadline", paymentDeadline)}
                            />
                            <span>before start time</span>
                        </span>
                    </SwitchField>
                    <SwitchField
                        size="medium"
                        isChecked={value.autoChargeOnDeadline}
                        onChange={(value) => handleChange("autoChargeOnDeadline", value)}
                    >
                        Automatically charge organizer&apos;s card for outstanding balance at this deadline
                    </SwitchField>
                </div>
            ) : null}
        </div>
    );
};
